import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RewardMetric, RewardsService } from '@services/member';
import { DomainService, Label, LanguageService } from '@services/public';
import { APIErrors, isAPIErrors } from '@util';
import { JDate } from 'jakapa-utilities-lite';

const PAGE_PATH: string = 'pages.member.dashboard.rewards.metrics.page';
const TODAY: JDate = new JDate();
const DEFAULT_START_DATE: string = new JDate(TODAY)
	.addDays((TODAY.weekday + 6) % 7)
	.toString();

@Component({
	selector: 'app-member-dashboard-rewards-metrics',
	templateUrl: './metrics.component.html',
	styleUrls: ['./metrics.component.scss'],
})
export class MemberDashboardRewardsMetricsComponent implements OnInit {
	metrics: Array<RewardMetric> = [];
	form: UntypedFormGroup;

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
		score: '',
		extraCredit: '',
		noMetrics: '',
	};
	labels: { [key: string]: string } = {
		[Label.ONBOARDING]: '',
		[Label.SELECT_DATE]: '',
		[Label.TO]: '',
	};

	constructor(
		private _domainSvc: DomainService,
		private _languageSvc: LanguageService,
		private _rewardSvc: RewardsService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page) {
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
			}
		});
		this._languageSvc.getLabels(this.labels);

		// Initialize form.
		this.form = new UntypedFormGroup({ date: new UntypedFormControl(null) });

		// Load metrics.
		this._rewardSvc
			.loadMetricsData(DEFAULT_START_DATE)
			.subscribe((res: Array<RewardMetric> | APIErrors) => {
				if (!isAPIErrors(res)) this._loadMetrics(res);
			});
	}

	private _loadMetrics(metrics: Array<RewardMetric>) {
		this.metrics = metrics.map((metric) => {
			metric.domain = this._domainSvc.getDomain(metric.domainUID).name;
			metric.class = 'metric';
			if (metric.score < 60) metric.class += ' incomplete';
			return metric;
		});
	}

	dateOnSelect(date: Date): void {
		this._rewardSvc
			.loadMetricsData(new JDate(date).toString())
			.subscribe((res: Array<RewardMetric> | APIErrors) => {
				if (!isAPIErrors(res)) this._loadMetrics(res);
			});
	}
}
